var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShop(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1_ico/shop") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1_ico/shop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#616161",
    points: "2 7 5 7 5 2 2 2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    fill: "#616161",
    points: "15 7 18.001 7 18.001 2 15 2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#616161",
    points: "10 7 14 7 14 2 10 2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#616161",
    points: "6 7 9.001 7 9.001 2 6 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,8.0001 L2,18.0001 L11,18.0001 L11,11.0001 L16,11.0001 L16,18.0001 L18,18.0001 L18,8.0001 L2,8.0001 Z M5,15.0011 L8.001,15.0011 L8.001,11.0001 L5,11.0001 L5,15.0011 Z",
    id: "Fill-5",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#616161",
    points: "12 16 13 16 13 12.999 12 12.999"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.cf7189b14398cab6bc0bae0363d58bc5.svg";
export { ForwardRef as ReactComponent };